// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M11.9986 28.0051H6.66302C5.18964 28.0051 3.99524 26.8107 3.99524 25.3373V6.66289C3.99524 5.18952 5.18964 3.99512 6.66302 3.99512H22.6697C24.1431 3.99512 25.3375 5.18952 25.3375 6.66289V10.6646"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M15.9998 28.0058 19.4999 27.5736C19.7461 27.5431 19.9752 27.4314 20.1508 27.2561L28.6317 18.7753C29.571 17.8399 29.5746 16.3203 28.6397 15.3805L28.6317 15.3739V15.3739C27.6963 14.4345 26.1767 14.4309 25.2369 15.3658V15.3739L16.8334 23.7774C16.6625 23.9471 16.5519 24.1683 16.5186 24.4069L15.9998 28.0058ZM10.6647 22.6706V22.6706C9.55962 22.6706 8.66382 21.7748 8.66382 20.6698V20.6698C8.66382 19.5647 9.55962 18.6689 10.6647 18.6689V18.6689C11.7697 18.6689 12.6655 19.5647 12.6655 20.6698V20.6698C12.6655 21.7748 11.7697 22.6706 10.6647 22.6706Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M8.66382 9.33198H19.3349M8.66382 14H13.9994"
    />
  </svg>
);
const IconEditNote = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconEditNote;
